// extracted by mini-css-extract-plugin
module.exports = {"commentsFromDealerContainer":"_1Vw1S","commentsFromDealerHeading":"_2kyU6","commentsFromDealer":"fDDQR","commentsFromDealerExpanded":"_2wPCW","readMore":"RB8oC"};